// Override
var PostLayout = function (parent, newWidth, newHeight) {
    return this;
}

export default PostLayout;